import { useAdDetailsContext } from '../../../../../../contexts/AdDetailsContext';
import { useWhatsappAction } from './useWhatsAppAction';

const useContactDealershipBottomSheet = (args: {
  adId: number;
  sectionName?: string;
  price?: string | null;
  priceEuro?: number | null;
  sellerType?: string;
}) => {
  const { adId, sectionName, price, priceEuro, sellerType } = args;

  const { isContactSellerModalOpen, setIsContactSellerModalOpen } =
    useAdDetailsContext();

  const { onWhatsAppButtonClick, isLoading } = useWhatsappAction({
    adId,
    sectionName,
    price,
    priceEuro,
    sellerType,
  });

  const closeContactSellerModal = () => setIsContactSellerModalOpen(false);

  return {
    isContactSellerModalOpen,
    onWhatsAppButtonClick,
    isLoading,
    closeContactSellerModal,
  };
};

export { useContactDealershipBottomSheet };
